import axios from "@/config/axiosConfig";

export const getGSTR2aReportCompare = (fileData, params) => {
    return async (dispatch, getState) => { 
        try {
            const { auth } = getState();
            const formData = new FormData();
            formData.append("data", JSON.stringify(fileData));

            const defaultParams = {
                finyearId: auth.finyear?.id,
                companyId: auth.company?.id,
                customerId: auth.customer?.id,
                preventUpdate: true,
            };
            
            const requestParams = { ...defaultParams, ...params };

            return axios.post('/gstr2b-report/getReportCompare', formData, { params: requestParams })
            .then((response) => {
                if (response) {
                    console.log("Actions Api Call" , response);
                    
                    return response;
                } else {
                    throw new Error(response.data?.message || 'Failed to fetch GSTR2 report');
                }
            }).catch((error) => {
                console.error("Error fetching GSTR2A Report:", error);
                throw error;
            });
        } catch (error) {
            console.error("Error fetching GSTR2A Report:", error);
            throw error;
        }
    };
};
